import type { InitOptions, Resource } from 'i18next';

export const buildI18nOptions = (resources: Resource): InitOptions => {
    return {
        resources,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    };
};

export const COMMON_NAMESPACE = { ns: 'common' };
